import React from 'react';
import AuthenticationLayout from '../../layouts/authenticationLayout';
import LoginForm from './components/loginForm';

const LoginPage = () => {
  return (
    <AuthenticationLayout
      title="Welcome to Attendance System"
      subtitle="Sign in to access your attendance system"
    >
      <LoginForm />
    </AuthenticationLayout>
  );
};

export default LoginPage;